import LongLat from "@mapmycustomers/shared/types/base/LongLat";
import { Territory } from "@mapmycustomers/shared/types/entity";
import {
  convertMultiPolygonToBeOfLatLngLiterals,
  convertPolygonToBeOfLatLngLiterals,
} from "@mapmycustomers/shared/util/territory/convertLongLatGeoShapesToLatLngLiteral";

const removeLastPathCoordinateFromPolygon = (polygon: LongLat[][]) =>
  polygon.map((path) => (path.length >= 2 ? path.slice(0, -1) : path));

const territoryGeometryGetter = (
  territory: Territory
): Exclude<google.maps.Data.FeatureOptions["geometry"], undefined> | undefined => {
  if (territory.territoryDetail.type === "points") {
    return new google.maps.Data.Polygon(
      convertPolygonToBeOfLatLngLiterals(territory.territoryDetail.points.coordinates)
    );
  } else if (territory.territoryDetail.shape) {
    return territory.territoryDetail.shape.type === "Polygon"
      ? new google.maps.Data.Polygon(
          convertPolygonToBeOfLatLngLiterals(
            removeLastPathCoordinateFromPolygon(territory.territoryDetail.shape.coordinates)
          )
        )
      : new google.maps.Data.MultiPolygon(
          convertMultiPolygonToBeOfLatLngLiterals(
            territory.territoryDetail.shape.coordinates.map(removeLastPathCoordinateFromPolygon)
          )
        );
  } else {
    return undefined;
  }
};

export default territoryGeometryGetter;
